// Tab keys of the object builder (`?tab=`). A light module: the route's search schema imports it
// without pulling the builder into the first-paint bundle.
export type ObjectTab =
  | 'fields'
  | 'relations'
  | 'layout'
  | 'templates'
  | 'views'
  | 'forms'
  | 'rules'
  | 'behavior'
  | 'translations'
  | 'permissions';
export const OBJECT_TABS: ObjectTab[] = [
  'fields',
  'relations',
  'layout',
  'templates',
  'views',
  'forms',
  'rules',
  'behavior',
  'translations',
  'permissions',
];
